import {
  DateRangePicker,
  DateRangePickerProps,
  MultiInputDateRangeField,
} from '@mui/x-date-pickers-pro'
import { useLocalizedDate } from '../../hooks/localized-date'
import {
  FieldPath,
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form'
import { CalendarIcon } from '@sitoo/mui-components'
import { UseDesktopRangePickerSlotProps } from '@mui/x-date-pickers-pro/internals/hooks/useDesktopRangePicker'
import { SxProps, Theme } from '@mui/material'

type Props<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = DateRangePickerProps &
  UseControllerProps<TFieldValues, TName> & {
    label?: string
    slotProps?: UseDesktopRangePickerSlotProps<true> & {
      field?: {
        sx?: SxProps<Theme>
      }
    }
  }

export const DateRangePickerInput = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>(
  props: Props<TFieldValues, TName>,
) => {
  const { getDateFormat } = useLocalizedDate()
  const dateFormat = getDateFormat()

  const { name, control, ...dateRangeProps } = props
  const { field } = useController({ name, control })

  return (
    <DateRangePicker
      calendars={2}
      {...field}
      {...dateRangeProps}
      format={dateFormat}
      onChange={(value) => field.onChange(value)}
      slots={{ field: MultiInputDateRangeField }}
      slotProps={{
        field: {
          dateSeparator: '',
          ...dateRangeProps.slotProps?.field,
          // @ts-expect-error it does support sx
          sx: {
            gap: 2,
            '.MuiFormControl-root': { ml: 0 },
            '.MuiMultiInputDateRangeField-separator': {
              display: 'none',
            },
            ...dateRangeProps.slotProps?.field?.sx,
          },
        },
        textField: {
          autoComplete: 'off',
          InputProps: {
            endAdornment: <CalendarIcon />,
          },
        },
      }}
    />
  )
}
